module.exports = __webpack_public_path__ + "assets/img/d1e76f89186d9655c1618424a6fcf08f.png";